import { createRouter, createWebHistory } from 'vue-router';
import i18n from '@/plugins/i18n';
import Home from '../views/Home.vue';
import store from '../store/index';
import UserVerification from '../rennovation/planning-view/components/Presentation/UserVerification.vue';
import DateRangePickerDemo from '../rennovation/planning-view/components/DateRangePickerDemo';
import PlanningSubView from '../rennovation/planning-view/containers/PlanningSubView.vue';
import Planning from '../rennovation/planning-view/containers/PlanningViewMain.vue';

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home,

		redirect: '/planning',
		meta: {
			requiresAuth: true,
			permission: 'duties.read',
		},
	},
	{
		path: '/planning',
		name: 'Planning',
		component: Planning,
		meta: {
			requiresAuth: true,
			permission: 'duties.read',
			title: 'title_planning',
		},
	},
	{
		path: '/planning-new-sub',
		name: 'PlanningSubView',
		component: PlanningSubView,
	},
	{
		path: '/planning-new/date-range-picker',
		name: 'DateRangePickerDemo',
		component: DateRangePickerDemo,
	},
	/*{
	   path: '/:tenant/',
	   name: 'Login',
	   component: Login,
	},*/
	{
		path: '/user-test',
		name: 'UserVerification',
		component: UserVerification,
	},
	{
		path: '/users',
		name: 'Users',
		component: () => import('../modules/users/views/Users.vue'),
		meta: {
			requiresAuth: true,
			permission: 'users.read',
			title: 'title_users',
		},
	},
	{
		path: '/userGroups',
		name: 'UserGroups',
		component: () => import('../modules/userGroup/views/UserGroups.vue'),
		meta: {
			requiresAuth: true,
			permission: 'groups.read',
			title: 'title_user_groups',
		},
	},
	{
		path: '/solution/:id?',
		name: 'Solution Center',
		component: () => import('../modules/solution/views/Solution.vue'),
		meta: {
			requiresAuth: true,
			permission: 'duties.read',
			title: 'title_solution',
		},
	},
	{
		path: '/user/:id',
		name: 'User',
		component: () => import('../modules/users/views/User.vue'),
		meta: {
			requiresAuth: true,
			permission: 'users.read',
			title: 'title_user',
		},
	},
	{
		path: '/roles',
		name: 'Roles',
		component: () => import('../modules/roles/views/Roles.vue'),
		meta: {
			requiresAuth: true,
			permission: 'roles.read',
			title: 'title_roles',
		},
	},

	{
		path: '/core',
		name: 'Core',
		component: () => import('../modules/core/views/CoreDashboard.vue'),
		meta: {
			requiresAuth: true,
			permission: 'core.read',
			title: 'title_core',
		},
	},
	{
		path: '/basic-fitness',
		name: 'BasicFitness',
		component: () => import('../modules/basicFitness/views/BasicFitness.vue'),
		meta: {
			requiresAuth: true,
			onlySuperuser: true,
			permission: 'core.read',
			title: 'title_basic_fitness',
		},
	},
	{
		path: '/adapters/status',
		name: 'AdapterStatus',
		component: () => import('../modules/adapters/views/AdapterStatus.vue'),
		meta: {
			requiresAuth: true,
			permission: 'adapters.read',
			title: 'title_adapterStatus',
		},
	},
	{
		path: '/adapters/manage',
		name: 'AdapterManage',
		component: () => import('../modules/adapters/views/AdapterManage.vue'),
		meta: {
			requiresAuth: true,
			onlySuperuser: true,
			permission: 'adapters.edit',
			title: 'title_adapterManage',
		},
	},
	{
		path: '/performanceMetrics',
		name: 'PerformanceMetrics',
		component: () => import('../modules/performanceMetrics/views/performanceMetrics.vue'),
		meta: {
			requiresAuth: true,
			onlySuperuser: true,
			permission: null,
			title: 'title_performance_metrics',
		},
	},
	{
		path: '/setup',
		name: 'Setup',
		component: () => import('../modules/setup/views/Setup.vue'),
		meta: {
			requiresAuth: true,
			permission: ['setup.customization', 'dump.import', 'dump.export'],
			title: 'title_setup',
		},
	},
	{
		path: '/dutyExchange',
		name: 'dutyEchange',
		component: () => import('../modules/dutyexchange/DutyExchange.vue'),
		meta: {
			requiresAuth: true,
			permission: 'exchange.read',
			title: 'title_dutyExchange',
		},
	},
	{
		path: '/app-api-key',
		name: 'app-api-key',
		component: () => import('../modules/apiKey/views/ApiKey.vue'),
		meta: {
			requiresAuth: true,
			permission: 'apikey.read',
			title: 'title_apiKey',
		},
	},
	{
		path: '/qualification',
		name: 'Qualification',
		component: () => import('../modules/qualification/views/Qualification.vue'),
		meta: {
			requiresAuth: true,
			permission: 'qualification.read',
			title: 'title_qualification',
		},
	},
	{
		path: '/login',
		name: 'Login',
		component: () => import('../views/Login.vue'),
		meta: {
			guest: true,
			title: 'title_login',
		},
	},
	{
		path: '/register',
		name: 'Register',
		component: () => import('../views/Register.vue'),
		meta: {
			guest: true,
			title: 'title_register',
		},
	},
	{
		path: '/passwordResetRequest',
		name: 'Password Reset Request',
		component: () => import('../views/PasswordResetRequest.vue'),
		meta: {
			guest: true,
			title: 'title_passwordResetRequest',
		},
	},
	{
		path: '/passwordReset',
		name: 'Password Reset',
		component: () => import('../views/PasswordReset.vue'),
		meta: {
			guest: true,
			title: 'title_passwordReset',
		},
	},
	{
		path: '/myProfile',
		name: 'My Profile',
		component: () => import('../modules/profile/views/MyProfile.vue'),
		meta: {
			requiresAuth: true,
			permission: 'login.web',
		},
	},
	{
		path: '/passwordChange',
		name: 'PasswortÄndern',
		component: () => import('../views/ChangePassword.vue'),
		meta: {
			requiresAuth: true,
			permission: 'login.web',
		},
	},
	{
		path: '/languagePicker',
		name: 'LanguagePicker',
		component: () => import('../common/locales/views/LanguagePicker.vue'),
		meta: {
			requiresAuth: true,
			permission: 'login.web',
		},
	},
	{
		path: '/plugin',
		name: 'Plugin',
		component: () => import('../modules/plugin/views/Plugin.vue'),
		meta: {
			requiresAuth: true,
			permission: 'plugins.edit',
			title: 'title_plugin',
		},
	},
	{
		path: '/extraPay',
		name: 'ExtraPay',
		component: () => import('../modules/extraPay/views/ExtraPay.vue'),
		meta: {
			requiresAuth: true,
			permission: 'salaries.read',
			title: 'title_extraPay',
		},
	},
	{
		path: '/violations',
		name: 'Violations',
		component: () => import('../modules/violation/views/Violations.vue'),
		meta: {
			requiresAuth: true,
			permission: 'statistics.read',
			title: 'title_violations',
		},
	},
	{
		path: '/statisticsOverview',
		name: 'StatisticsOverview',
		component: () => import('../modules/statisticsOverview/views/StatisticsOverview.vue'),
		meta: {
			requiresAuth: true,
			permission: 'statistics.read',
			title: 'title_statisticsOverview',
		},
	},
	{
		path: '/absenceStatistics',
		name: 'AbsenceStatistics',
		component: () => import('../modules/absenceStatistics/views/AbsenceStatistics.vue'),
		meta: {
			requiresAuth: true,
			permission: 'statistics.read',
			title: 'title_absenceStatistics',
		},
	},
	{
		path: '/rotation',
		name: 'Rotation',
		component: () => import('../../plugins/Rotation/web/views/Rotation.vue'),
		meta: {
			requiresAuth: true,
			permission: 'rotation.read',
			title: 'title_rotation',
		},
	},
	{
		path: '/worktimesummary',
		name: 'WorktimeSummary',
		component: () => import('../modules/worktimeSummary/views/WorktimeSummary.vue'),
		meta: {
			requiresAuth: true,
			permission: 'statistics.read',
			title: 'title_worktimeSummary',
		},
	},
	{
		path: '/extraWorkReport',
		name: 'ExtraWorkReport',
		component: () => import('../modules/ExtraWorkReport/views/ExtraWorkReport.vue'),
		meta: {
			requiresAuth: true,
			permission: 'reports.read',
			title: 'extra_work_report',
		},
	},
	{
		path: '/dutyTemplates',
		name: 'DutyTemplates',
		component: () => import('../modules/dutyTemplates/views/DutyTemplates.vue'),
		meta: {
			requiresAuth: true,
			permission: 'duties.read',
			title: 'title_DutyTemplates',
		},
	},
	{
		path: '/scores',
		name: 'Scores',
		component: () => import('../modules/userScores/views/Scores.vue'),
		meta: {
			requiresAuth: true,
			permission: 'statistics.read',
			title: 'title_scores',
		},
	},
	{
		path: '/forbidden',
		name: 'Forbidden',
		component: () => import('../views/Forbidden.vue'),
		meta: {
			guest: true,
			title: 'title_forbidden',
		},
	},
	{
		path: '/app',
		redirect: (to) => {
			if (import.meta.env.DEV) {
				console.warn('[router-web] Standalone dev environment detected. Skipping hard redirect to /app/.');
				return '/planning';
			}
			window.location.href = '/app/';
			return '/app/';
		},
	},
	{
		path: '/:pathMatch(.*)*',
		redirect: (to) => {
			window.location.href = '/login';
			return '/login';
		},
	},
];
const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes,
});

router.beforeEach((to, from) => beforeEach(to, from));

router.afterEach((to) => {
	const baseTitle = 'Hirsch';
	if (to.meta?.title) {
		const translated = i18n.global.t(to.meta.title);
		document.title = `${translated}`;
	} else {
		document.title = baseTitle;
	}
});

async function ensureAuthenticated() {
	if (!store.getters['auth/isLoggedIn']) {
		await store.dispatch('auth/load');
	}
}

export async function beforeEach(to, from) {
	await ensureAuthenticated();

	if (to.matched.some((record) => record.meta.requiresAuth)) {
		return checkPermissions(to);
	} else if (to.matched.some((record) => record.meta.guest)) {
		return handleGuestRoutes(to);
	}

	if (from?.path === '/planning') {
		window.leavingPlanningAt = performance.now();
	}

	return true;
}

const checkPermissions = async (to) => {
	await ensureAuthenticated();
	const userPermissions = store.state.auth.user?.permissions;
	const routePermissions = to.meta.permission;

	if (store.getters['auth/isLoggedIn']) {
		const isPermittedForRoute = (userPermissions, routePermissions) => {
			if (routePermissions == null) {
				if (to.meta.onlySuperuser && store.state.auth.user.superuser) {
					return true;
				}
			}
			if (Array.isArray(routePermissions)) {
				return routePermissions.some((currentPermission) => userPermissions[currentPermission]);
			}
			return userPermissions[routePermissions] || false;
		};

		if (isPermittedForRoute(userPermissions, routePermissions) && userPermissions['login.web'] !== undefined) {
			if (to.meta.onlySuperuser && !store.state.auth.user.superuser) {
				return '/forbidden';
			}
			return true;
		} else {
			return '/forbidden';
		}
	} else {
		return '/login';
	}
};

const handleGuestRoutes = async (to) => {
	if (store.state.auth.token || store.state.auth.user) {
		await store.dispatch('auth/load');
	}
	if (store.getters['auth/isLoggedIn'] && (to.path === '/login' || to.path === '/register')) {
		return '/';
	} else {
		return true;
	}
};

export default router;
